<template>
  <Transition name="fade">
    <div 
      id="gdpr-modal" 
      role="dialog" 
      aria-modal="true" 
      :aria-labelledby="lst(dapLangGlobal.gdprModal.title, ls(dapLangGlobal.serviceName))"
      v-if="privacyStore.showPrivacyModal"
    >
      <h1 class="jps-heading-small">
        {{
          lst(dapLangGlobal.gdprModal.title, ls(dapLangGlobal.serviceName))
        }}
      </h1>
      <div v-if="!isSnowDetails" class="is-size-7-desktop is-size-7-touch">
        <p>
          {{
            lst(dapLangGlobal.gdprModal.details, config.public.serviceBaseUrl)
          }}
        </p>
      </div>
      <div v-if="isSnowDetails" class="is-size-7-desktop is-size-7-touch">
        <h2 class="jps-heading-small">
          {{
            ls(dapLangGlobal.gdprModal.strictlyNecessary)
          }}
        </h2>
        <ul>
          <li>
            {{
              ls(dapLangGlobal.gdprModal.strictlyNecessary1)
            }}
          </li>
          <li>
            {{
              ls(dapLangGlobal.gdprModal.strictlyNecessary2)
            }}
          </li>
        </ul>
        <h2 class="jps-heading-small">
          {{
            ls(dapLangGlobal.gdprModal.acceptAnalyticsCookies)
          }}
        </h2>
        <ul>
          <li>
            {{
              ls(dapLangGlobal.gdprModal.acceptAllCookiesDescription)
            }}
          </li>
        </ul>
        <p>
          {{
            ls(dapLangGlobal.gdprModal.acceptAllCookiesDescription1)
          }}
        </p>
        <p>
          {{ ls(dapLangGlobal.gdprModal.acceptAllCookiesDescription2.prefix) }}<BaseLink to="/policy/privacy"
          >{{ ls(dapLangGlobal.gdprModal.acceptAllCookiesDescription2.base) }}</BaseLink
          >{{ ls(dapLangGlobal.gdprModal.acceptAllCookiesDescription2.suffix) }}
        </p>
      </div>
      <div class="jps-button-group gdpr-modal-button-list">
        <button 
          role="button"
          :aria-label="ls(dapLangGlobal.gdprModal.strictlyNecessaryCookies)"
          class="jps-round-button"
          @click="onClickAcceptMinimum()"
        >
          {{ ls(dapLangGlobal.gdprModal.strictlyNecessaryCookies) }}
        </button>
        <button
          v-if="!isSnowDetails"
          role="button"
          :aria-label="ls(dapLangGlobal.gdprModal.forMoreInformation)"
          class="jps-round-button"
          @click="showDetails()"
        >
          {{ ls(dapLangGlobal.gdprModal.forMoreInformation) }}
        </button>
        <button
          v-if="isSnowDetails"
          role="button"
          :aria-label="ls(dapLangGlobal.gdprModal.hideInformation)"
          class="jps-round-button"
          @click="hideDetails()"
        >
          {{ ls(dapLangGlobal.gdprModal.hideInformation) }}
        </button>
        <button
          role="button"
          :aria-label="ls(dapLangGlobal.gdprModal.acceptAllCookies)"
          class="jps-round-button"
          @click="onClickAcceptAll()"
        >
          {{ ls(dapLangGlobal.gdprModal.acceptAllCookies) }}
        </button>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import { useState } from 'vue-gtag-next'

const { ls, lst } = useI18n()
const config = useRuntimeConfig()
const { isEnabled } = useState()
const privacyStore = usePrivacyStore()

interface Props {
}
const props = withDefaults(defineProps<Props>(), {
})

const isSnowDetails: Ref<boolean> = ref(false)

const initDisplay = () => {
  nextTick(() => {
    if (privacyStore.gdprAcceptTracking) {
      enableTracking()
      return
    }
  })
}
onMounted(initDisplay)

const showDetails = () => {
  isSnowDetails.value = true
}

const hideDetails = () => {
  isSnowDetails.value = false
}

const onClickAcceptAll = () => {
  confirmPolicy()
  enableTracking()
}

const onClickAcceptMinimum = () => {
  privacyStore.gdprAcceptTracking = false
  confirmPolicy()
  isEnabled.value = false
}

const enableTracking = () => {
  privacyStore.gdprAcceptTracking = true
  isEnabled.value = true
}

const confirmPolicy = () => {
  privacyStore.gdprConfirmed = true
  privacyStore.showPrivacyModal = false
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

#gdpr-modal {
  width: 40vw;
  padding: 1rem;
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  border: 1px solid $jps-gray-300;
  border-radius: $global-radius;
  z-index: 800;
  background: $white;
  color: $black;
  @include popup-shadow();
  @include is-mobile() {
    width: 100%;
    bottom: 0;
    left: 0;
  }
}

.gdpr-modal-button-list {
  flex-wrap: wrap;
}
</style>
